import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '顧問契約の料金はどのくらいですか？',
      answer: '企業規模や業種、サービス内容によって異なりますが、月額3万円からご提供しております。初回相談時に詳しくお見積りいたしますので、お気軽にお問い合わせください。',
    },
    {
      question: '税務調査の立ち会いもお願いできますか？',
      answer: 'はい、税務調査の立ち会いも対応しております。事前準備から当日の立ち会い、調査後のフォローまで、全面的にサポートいたします。',
    },
    {
      question: '会計ソフトの導入支援はありますか？',
      answer: '各種会計ソフトの導入支援を行っております。お客様の業種や規模に最適なソフトをご提案し、初期設定から操作指導まで丁寧にサポートいたします。',
    },
    {
      question: '個人事業主ですが、法人化のタイミングについて相談できますか？',
      answer: 'もちろん可能です。売上規模や利益状況、将来の事業計画などを総合的に分析し、最適な法人化のタイミングをアドバイスいたします。',
    },
    {
      question: '経営相談だけでもお願いできますか？',
      answer: 'はい、経営相談のみのご依頼も承っております。資金繰り、事業計画、経営改善など、幅広いテーマでご相談いただけます。',
    },
    {
      question: '遠方からでも依頼できますか？',
      answer: '京都市内を中心にサービスを提供しておりますが、オンライン面談やメール・電話でのサポートも可能です。まずはお気軽にご相談ください。',
    },
    {
      question: '決算だけお願いすることは可能ですか？',
      answer: '決算申告のみのご依頼も承っております。ただし、より正確な申告と節税対策のため、年間を通じた顧問契約をおすすめしております。',
    },
    {
      question: '相続税の相談もできますか？',
      answer: 'はい、相続税の申告や事前対策についてもご相談いただけます。相続財産の評価から申告書作成まで、トータルでサポートいたします。',
    },
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1000px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block mb-4 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
            <span className="text-red text-[13px] font-medium">FAQ</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            よくある質問
          </h2>
          <p className="text-gray-600 text-lg">
            お客様からよくいただくご質問にお答えします
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm hover:shadow-md transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-red font-bold text-sm">Q</span>
                  </div>
                  <span className="text-lg font-bold text-gray-900 flex-1">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-red transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <div className="flex items-start gap-4 pl-14">
                    <div className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
